
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs/[author]/home",
      function () {
        return require("private-next-pages/labs/[author]/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labs/[author]/home"])
      });
    }
  